export default __webpack_public_path__ + "static/media/imgMoKeyFeature7.1bb32978.png";